
export const STATUS_LABELS = {
    draft:     'draft',
    pending:   'pending',
    paid:      'paid',
    cancelled: 'cancelled',
    overdue:   'overdue'
};

/**
 * Computes the invoice status, identifying 'overdue' if pending and past due date.
 * IMPORTANT: This logic MUST be kept in sync with the backend:
 * - Invoices.php: applyStatusFilter()
 * - Invoices.php: summary() query
 */
export function computeInvoiceStatus(status, dueDate) {
    if (status === 'pending' && dueDate) {
        const due   = new Date(String(dueDate).substring(0, 10) + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (!isNaN(due.getTime()) && due < today) {
            return 'overdue';
        }
    }
    return status;
}

export function extractApiError(errOrResponse, fallback = 'Error') {
    if (!errOrResponse) return fallback;
    const body = errOrResponse.body
        || (errOrResponse.response && errOrResponse.response.data)
        || {};
    return body.error || body.message || fallback;
}

export function formatMonthYear(dateStr, locale = 'pt-BR') {
    if (!dateStr) return '';
    const d = new Date(String(dateStr).replace(' ', 'T'));
    if (isNaN(d.getTime())) return dateStr;
    const s = d.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
    return s.charAt(0).toUpperCase() + s.slice(1);
}


